import React from "react";

const GeneralTable = (props) => {
  const {
    rows,
    cols,
    rowKey,
    isLoading,
    onRowClick,
    hasSelection,
    selection,
    setSelection,
  } = props;

  const isEmpty = !isLoading && rows.length === 0;
  const isHoverable = typeof onRowClick === "function" ? "is-hoverable" : "";

  const handleSelectRow = (event, it) => {
    let copy;
    if (event.target.checked) {
      copy = selection.map((x) => x);
      copy.push(it);
    } else {
      copy = selection.filter((i) => i !== it);
    }

    setSelection(copy);
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelection(rows.map((_, it) => it));
    } else {
      setSelection([]);
    }
  };

  return (
    <div className="card">
      <table
        className={`table is-striped is-fullwidth has-text-grey ${isHoverable}`}
      >
        <thead>
          <tr>
            {hasSelection ? (
              <th style={{ width: "1px" }}>
                <label className="checkbox">
                  <input
                    type="checkbox"
                    title="Select all"
                    checked={selection.length > 0}
                    onChange={handleSelectAll}
                  />
                </label>
              </th>
            ) : null}
            {cols.map((col, jt) => (
              <th key={jt} className={col.className}>
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan={cols.length}>
                <div className="hero">
                  <div className="hero-body has-text-centered">
                    <h1 className="title">Cargando</h1>
                    <h2 className="subtitle">Cargando información</h2>
                  </div>
                </div>
              </td>
            </tr>
          ) : null}

          {isEmpty ? (
            <tr>
              <td colSpan={cols.length + (hasSelection ? 1 : 0)}>
                <div className="hero">
                  <div className="hero-body has-text-centered">
                    <h1 className="title">Sin resultados</h1>
                    <h2 className="subtitle">No se encontraron resultados</h2>
                  </div>
                </div>
              </td>
            </tr>
          ) : null}

          {rows.map((row, it) => (
            <tr
              key={rowKey ? row[rowKey] : it}
              onClick={(event) =>
                onRowClick ? onRowClick(row, event, it) : null
              }
            >
              {hasSelection ? (
                <td>
                  <label className="checkbox">
                    <input
                      type="checkbox"
                      checked={selection.indexOf(it) !== -1}
                      onChange={(event) => handleSelectRow(event, it)}
                    />
                  </label>
                </td>
              ) : null}
              {cols.map((col, jt) => (
                <td key={jt}>{col.render(row)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default GeneralTable;
